<section id="inicio">
    <mdb-carousel class="carousel slide carousel-fade" [animation]="'fade'">
        <mdb-carousel-item>
            <a class="pointer" [routerLink]="['/home/presentacion']">
                <div class="view w-100 pointer">
                    <!-- <img class="d-block w-100" src="/assets/images/micrositio/homepage/HOME_001e.jpg"> -->
                    <img class="d-block w-100" src="/assets/images/micrositio/homepage/HOME_001b2.png">
                    <div class="mask rgba-black-slight waves-light" mdbWavesEffect></div>
                </div>
            </a>
        </mdb-carousel-item>
        <mdb-carousel-item>
            <a class="pointer" [routerLink]="['/home/generica1']">

                <div class="view w-100 pointer">
                    <!-- <img class="d-block w-100" src="/assets/images/micrositio/homepage/HOME_001b2.png"> -->
                     <img class="d-block w-100" src="/assets/images/micrositio/homepage/HOME_001e.jpg">
                    <div class="mask rgba-black-slight waves-light" mdbWavesEffect></div>
                </div>
            </a>
        </mdb-carousel-item>
        <mdb-carousel-item>
            <a class="pointer" [routerLink]="['/home/generica2']">
                <div class="view w-100 pointer">
                    <img class="d-block w-100" src="/assets/images/micrositio/homepage/HOME_001a.jpg">
                    <div class="mask rgba-black-slight waves-light" mdbWavesEffect></div>
                </div>
            </a>
        </mdb-carousel-item>
        <mdb-carousel-item>
            <a class="pointer" [routerLink]="['/home/generica3']">

                <div class="view w-100 pointer">
                    <img class="d-block w-100" src="/assets/images/micrositio/homepage/HOME_001c.jpg">
                    <div class="mask rgba-black-slight waves-light" mdbWavesEffect></div>
                </div>
            </a>
        </mdb-carousel-item>
        <mdb-carousel-item>
            <a class="pointer" [routerLink]="['/home/generica4']">
                <div class="view w-100 pointer">
                    <img class="d-block w-100" src="/assets/images/micrositio/homepage/HOME_001d.jpg">
                    <div class="mask rgba-black-slight waves-light" mdbWavesEffect></div>
                </div>
            </a>
        </mdb-carousel-item>
    </mdb-carousel>
</section>

<div class="fondoAzul" id="temas">
    <div class="col-sm-12 margTemas">
        <div class="row p2">
            <div class="col-sm-1">
            </div>
            <div class="col-sm-10">
                <div class="row">
                    <div class="col-sm-5">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/homepage/HOME_LINEA3-recortada.png">
                    </div>
                    <div class="col-sm-2">
                        <p style="line-height: 160%; margin-bottom: 0%;"
                            class="fontMS700 text-center text-white font-40 titleSubsec">
                            TEMAS
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/homepage/HOME_LINEA3-recortada.png">
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-2 text-center text-grey">
                        <a (click)="asignar('NUEVOS')">
                            <label class="{{factiveN}}">
                            <span class="borderTop">NUEVOS</span>
                            </label>
                        </a>
                    </div>
                    <div class="col-sm-2 text-center text-grey">
                        <a (click)="asignar('TODOS')">
                            <label class="{{factiveT}}">
                            <span class="borderTop">TODOS</span>
                            </label>
                        </a>
                    </div>
                    <div class="col-sm-2 text-center text-grey">
                        <a (click)="asignar('CREADORES')">
                            <label class="{{factiveC}}">
                            <span class="borderTop">CREADORES</span>
                            </label>
                        </a >
                    </div>
                    <div class="col-sm-2 text-center text-grey">
                        <a (click)="asignar('MIRADAS')">
                            <label class="{{factiveM}}">
                            <span class="borderTop">MIRADAS DESDE</span><br>
                            EL ARTE
                            </label>
                        </a>
                    </div>
                    <div class="col-sm-2 text-center text-grey">
                        <a (click)="asignar('COMUNIDADES')">
                            <label class="{{factiveCO}}">
                            <span class="borderTop">COMUNIDADES</span><br>
                            IMAGINADAS
                            </label>
                        </a>
                    </div>
                    <div class="col-sm-2 text-center text-grey">
                        <a (click)="asignar('TRANSICIONES')">
                            <label class="{{factiveTR}}">
                            <span class="borderTop">TRANSICIONES Y TRANSFORMACIONES</span><br>
                            SOCIALES
                            </label>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-sm-1">
            </div>
        </div>
    </div>
    <!-- CEL - WEB -->
    <div class="col-sm-12 margMenuWebPhone menuWebPhone">
        <!--MORADO-->
        <div class="row p2 fadeIn" *ngIf="morado == true">
            <div class="col-sm-1">
            </div>
            <!--MORADOS NUEVOS-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio16/dora-mayer']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_032.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio16/dora-mayer']" class="fontMS700 font-16 text-white text-center">
                        DORA MAYER<br> 
                        EL SOL QUE DISIPA<br>
                        LAS NUBES
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 17-MANUEL GONZALEZ PRADA-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio17/manuel-gonzalez-prada']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_033.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio17/manuel-gonzalez-prada']" class="fontMS700 font-16 text-white text-center">
                        MANUEL <br> 
                        GONZÁLEZ PRADA<br>
                        APUNTES PARA <br>
                        LA HISTORIA
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 19-RICARDO PALMA-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio19/ricardo-palma']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_036.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio19/ricardo-palma']" class="fontMS700 font-16 text-white text-center">
                        RICARDO PALMA<br>
                        GUARDIÁN DEL <br> 
                        PATRIMONIO EN <br> 
                        EL CAMBIO<br>
                        DE SIGLO
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 23- JORGE BASADRE-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio23/jorge-basadre']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_030.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio23/jorge-basadre']" class="fontMS700 font-16 text-white text-center">
                        JORGE BASADRE<br>
                        Y LA VOCACIÓN<br>
                        BIBLIOTECARIA EN<br>
                        EL PERÚ
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio10/pensadoresXIX']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_002.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio10/pensadoresXIX']" class="fontMS700 font-16 text-white text-center">
                        PENSADORAS <br>
                        PERUANAS <br>
                        DEL SIGLO XIX <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-1">
            </div>
        </div>

        <div class="row p2 fadeIn" *ngIf="morado == true">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio9/clorindaMatto']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_003.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio9/clorindaMatto']" class="fontMS700 font-16 text-white text-center">
                        CLORINDA MATTO <br>
                        DE TURNER <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio8/artePoeta']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_004.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio8/artePoeta']" class="fontMS700 font-16 text-white text-center">
                        EL ARTE DEL POETA<br>
                        JOSÉ MARÍA EGUREN <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio13/magda-portal']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_005.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio13/magda-portal']" class="fontMS700 font-16 text-white text-center">
                        MAGDA PORTAL<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio14/jose-maria-arguedas']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_006.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio14/jose-maria-arguedas']"
                        class="fontMS700 font-16 text-white text-center">
                        JOSÉ MARÍA <br>
                        ARGUEDAS <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio26/maria-alvarado']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_046.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio26/maria-alvarado']"
                        class="fontMS700 font-16 text-white text-center">
                        MARÍA JESÚS <br>
                        ALVARADO RIVERA <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-1"></div>
        </div>

        <div class="row p2 fadeIn" *ngIf="morado == true">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio34/fernando-garreaud']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_055.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio34/fernando-garreaud']" class="fontMS700 font-16 text-white text-center">
                        FERNANDO <br>
                        GARREAUD <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio37/bernardo-alzedo']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_037.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio37/bernardo-alzedo']"
                        class="fontMS700 font-16 text-white text-center">
                        BERNARDO<br>  ALZEDO
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio38/cesar-vallejo']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_038.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio38/cesar-vallejo']"
                        class="fontMS700 font-16 text-white text-center">
                        CÉSAR<br> VALLEJO
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio39/maria-wiesse']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_058.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio39/maria-wiesse']"
                        class="fontMS700 font-16 text-white text-center">
                        MARÍA<br> WIESSE
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio40/angelica-palma']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_059.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio40/angelica-palma']"
                        class="fontMS700 font-16 text-white text-center">
                        ANGÉLICA<br> PALMA
                    </p>
                </div>
            </div>
            <div class="col-sm-1"></div>
        </div>
        <div class="row p2 fadeIn" *ngIf="morado == true">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio41/nicomedes-santacruz']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_060.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio41/nicomedes-santacruz']" class="fontMS700 font-16 text-white text-center">
                        NICOMEDES <br>
                        SANTA CRUZ<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
            </div>
            <div class="col-sm-2 libro p3">
            </div>
            <div class="col-sm-2 libro p3">
            </div>
            <div class="col-sm-2 libro p3">
            </div>
            <div class="col-sm-1"></div>
        </div>
        
        <!--VERDE-->
        <div class="row p2 fadeIn" *ngIf="verde == true">
            <div class="col-sm-1">
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio18/noticieros']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_034.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio18/noticieros']" class="fontMS700 font-16 text-white text-center">
                        REPORTAJE Y <br>
                        PROPAGANDA:<br>
                        NOTICIARIOS <br>
                        CINEMATOGRÁFICOS <br>
                        PERUANOS DE <br> 
                        LOS 40<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio21/construccion-tradicion']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_035.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio21/construccion-tradicion']" class="fontMS700 font-16 text-white text-center">
                        LA CONSTRUCCIÓN<br>
                        DE LA TRADICIÓN:<br>
                        ACUARELAS<br> 
                        COSTUMBRISTAS<br>
                        DEL ÁLBUM PRAETORIA
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio3/retrato-foto']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_007.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio3/retrato-foto']" class="fontMS700 font-16 text-white text-center">
                        EL RETRATO <br>
                        FOTOGRÁFICO <br>
                        EN LIMA <br>
                        (1860-1930) <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio11/retratos-inmigracion']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_008.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio11/retratos-inmigracion']"
                        class="fontMS700 font-16 text-white text-center">
                        LOS RETRATOS <br>
                        DE LA INMIGRACIÓN <br>
                        DEL SIGLO XIX <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio2/compositores']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_015.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio2/compositores']" class="fontMS700 font-16 text-white text-center">
                        MÚSICA ANDINA,<br>
                        MESTIZA<br>
                        Y CRIOLLA EN LOS<br>
                        COMPOSITORES<br>
                        ACADÉMICOS<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-1">
            </div>
        </div>
        <div class="row p2 fadeIn" *ngIf="verde == true">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio12/malaga-grenet']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_010.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio12/malaga-grenet']" class="fontMS700 font-16 text-white text-center">
                        RETRATOS <br>
                        DE PRENSA <br>
                        LA PLUMA DE <br>
                        MÁLAGA GRENET <br>

                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio27/album-autografos']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_047.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio27/album-autografos']" class="fontMS700 font-16 text-white text-center">
                        ÁLBUM DE AUTÓGRAFOS <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio29/ex-libris']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_048.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio29/ex-libris']" class="fontMS700 font-16 text-white text-center">
                        DETRÁS DE LOS<br>EXLIBRIS EN EL <br>PERÚ <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio31/moda-siglo']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_049.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio31/moda-siglo']" class="fontMS700 font-16 text-white text-center">
                        MODA DEL SIGLO XIX<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio33/renacer-cenizas']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_054.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio33/renacer-cenizas']" class="fontMS700 font-16 text-white text-center">
                        RENACER DE LAS CENIZAS<br>
                        INCENDIO Y RECUPERACIÓN<br>
                        DE LA BIBLIOTECA NACIONAL<br>
                        DEL PERÚ
                    </p>
                </div>
            </div>
            <div class="col-sm-1"></div>
        </div>
        <div class="row p2 fadeIn" *ngIf="verde == true">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio42/noticieros2']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_034.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio42/noticieros2']" class="fontMS700 font-16 text-white text-center">
                        REPORTAJE Y<br>
                        PROPAGANDA:<br>
                        NOTICIARIOS<br>
                        CINEMATOGRÁFICOS<br>
                        PERUANOS DE<br>
                        LOS 40 (PARTE II)<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
            </div>
            <div class="col-sm-2 libro p3">
            </div>
            <div class="col-sm-2 libro p3">
            </div>
            <div class="col-sm-2 libro p3">
            </div>
            <div class="col-sm-1"></div>
        </div>

        <!--AZUL-->
        <div class="row p2 fadeIn" *ngIf="azul == true">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio20/derechos-mujer']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_031.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio20/derechos-mujer']" class="fontMS700 font-16 text-white text-center">
                        LOS DERECHOS DE <br>
                        LA MUJER <br>
                        PERUANA <br>
                        (1910-1956)
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio1/federalismo']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_016.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio1/federalismo']" class="fontMS700 font-16 text-white text-center">
                        FEDERALISMO Y<br>
                        RECONSTRUCCIÓN<br>
                        NACIONAL<br>
                        (1895-1899)<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio5/album-republica-peruana']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_009.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio5/album-republica-peruana']"
                        class="fontMS700 font-16 text-white text-center">
                        ÁLBUM<br> REPÚBLICA<br> PERUANA 1900
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio25/prensa-independencia']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_051.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio25/prensa-independencia']"
                        class="fontMS700 font-16 text-white text-center">
                        LA<br> PRENSA<br> EN LA INDEPENDENCIA
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio30/retratos-familiares']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_050.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio30/retratos-familiares']"
                        class="fontMS700 font-16 text-white text-center">
                        RETRATOS<br> FAMILIARES
                    </p>
                </div>
            </div>
            <div class="col-sm-1"></div>
        </div>

        <div class="row p2 fadeIn" *ngIf="azul == true">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio36/sesquicentenario']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_057.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio36/sesquicentenario']"
                        class="fontMS700 font-16 text-white text-center">
                        SESQUICENTENARIO
                    </p>
                </div>
            </div>
            <div class="col-sm-2"></div>
            <div class="col-sm-2"></div>
            <div class="col-sm-2"></div>
            <div class="col-sm-2"></div>
            <div class="col-sm-1"></div>
        </div>

        <!--AMARILLO-->
        <div class="row p2 fadeIn" *ngIf="amarillo == true">
            <div class="col-sm-1"></div>
            <!--NUEVO MICROSITIO 22- LA IMPRENTA-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio22/imprenta']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_038.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio22/imprenta']" class="fontMS700 font-16 text-white text-center">
                        LA IMPRENTA,<br>
                        LOS INCUNABLES Y<br> 
                        ESTAMPAS EN EL <br> 
                        VIRREINATO DEL PERÚ
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 24- INCA GARCILAZO DE LA VEGA-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio24/inca-garcilaso']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_037.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio24/inca-garcilaso']" class="fontMS700 font-16 text-white text-center">
                        INCA 
                        GARCILASO<br>
                        DE LA VEGA
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 28- Justo Sahuaraura-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio28/justo-sahuaraura']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_052.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio28/justo-sahuaraura']" class="fontMS700 font-16 text-white text-center">
                        RECUERDO DE LA <br>
                        MONARQUÍA <br>
                        PERUANA Ó<br>
                        BOSQUEJO DE LA<br>
                        HISTORIA DE LOS <br>
                        INCAS<br>
                    </p>
                </div>
            </div>

            <!--NARANJA-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio6/gramaticas']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_012.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio6/gramaticas']" class="fontMS700 font-16 text-white text-center">
                        GRAMÁTICAS, <br>
                        CATECISMOS Y <br>
                        VOCABULARIOS <br>
                        EN LENGUAS <br>
                        ORIGINARIAS <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio15/miradas-al-antiguo-peru']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_013.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio15/miradas-al-antiguo-peru']"
                        class="fontMS700 font-16 text-white text-center">
                        MIRADAS AL<br>
                        ANTIGUO PERÚ<br>
                        A INICIOS<br>
                        DEL SIGLO XX<br>
                    </p>
                </div>
            </div>
            
            <div class="col-sm-1"></div>
        </div>

        <div class="row p2 fadeIn" *ngIf="amarillo == true">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio4/la-educacion']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_014.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio4/la-educacion']" class="fontMS700 font-16 text-white text-center">
                        LA EDUCACIÓN<br>
                        EXPERIMENTAL<br>
                        EN EL ALTIPLANO <br>
                        (1930-1950)<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio7/himnos']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_011.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio7/himnos']" class="fontMS700 font-16 text-white text-center">
                        COMUNIDADES <br>
                        CANTADAS <br>
                        LAS COMPOSICIONES <br>
                        DE HIMNOS <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio32/memoria-recuperada']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_053.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio32/memoria-recuperada']" class="fontMS700 font-16 text-white text-center">
                        MEMORIA RECUPERADA <br>
                        LOS LIBROS DEVUELTOS <br>
                        POR CHILE
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio35/lenguas-originarias']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_056.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio35/lenguas-originarias']" class="fontMS700 font-16 text-white text-center">
                        LENGUAS <br>
                        ORIGINARIAS <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3"></div>
            <div class="col-sm-1"></div>
        </div>

        <!--NUEVOS-->
        <div class="row p2 fadeIn" *ngIf="nuevos == true">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio42/noticieros2']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_034.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio42/noticieros2']" class="fontMS700 font-16 text-white text-center">
                        REPORTAJE Y<br>
                        PROPAGANDA:<br>
                        NOTICIARIOS<br>
                        CINEMATOGRÁFICOS<br>
                        PERUANOS DE<br>
                        LOS 40 (PARTE II)<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio41/nicomedes-santacruz']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_060.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio41/nicomedes-santacruz']" class="fontMS700 font-16 text-white text-center">
                        NICOMEDES <br>
                        SANTA CRUZ<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio40/angelica-palma']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_059.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio40/angelica-palma']" class="fontMS700 font-16 text-white text-center">
                        ANGÉLICA<br>
                        PALMA <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio39/maria-wiesse']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_058.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio39/maria-wiesse']" class="fontMS700 font-16 text-white text-center">
                        MARÍA <br>
                        WIESSE <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio38/cesar-vallejo']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_038.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio38/cesar-vallejo']" class="fontMS700 font-16 text-white text-center">
                        CÉSAR<br> VALLEJO
                    </p>
                </div>
            </div>

            <div class="col-sm-1"></div>
        </div>

        <div class="row p2 fadeIn" *ngIf="nuevos == true">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio37/bernardo-alzedo']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_037.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio37/bernardo-alzedo']" class="fontMS700 font-16 text-white text-center">
                        BERNARDO<br>  ALZEDO
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio36/sesquicentenario']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_057.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio36/sesquicentenario']" class="fontMS700 font-16 text-white text-center">
                        SESQUICENTENARIO <br>
                        
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio34/fernando-garreaud']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_055.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio34/fernando-garreaud']" class="fontMS700 font-16 text-white text-center">
                        FERNANDO <br>
                        GARREAUD <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio35/lenguas-originarias']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_056.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio35/lenguas-originarias']" class="fontMS700 font-16 text-white text-center">
                        LENGUAS <br>
                        ORIGINARIAS <br>
                    </p>
                </div>
            </div>
            
            <div class="col-sm-2"></div>
            <div class="col-sm-1"></div>
        </div>


        <!--TODOS-->
        <!--MORADOS NUEVOS-->
        <div class="row p2" *ngIf="todos == true">
            <div class="col-sm-1">
            </div>
            <!--MORADOS NUEVOS-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio16/dora-mayer']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_032.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio16/dora-mayer']" class="fontMS700 font-16 text-white text-center">
                        DORA MAYER<br> 
                        EL SOL QUE DISIPA<br>
                        LAS NUBES
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 17-MANUEL GONZALEZ PRADA-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio17/manuel-gonzalez-prada']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_033.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio17/manuel-gonzalez-prada']" class="fontMS700 font-16 text-white text-center">
                        MANUEL <br> 
                        GONZÁLEZ PRADA<br>
                        APUNTES PARA <br>
                        LA HISTORIA
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 19-RICARDO PALMA-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio19/ricardo-palma']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_036.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio19/ricardo-palma']" class="fontMS700 font-16 text-white text-center">
                        RICARDO PALMA<br>
                        GUARDIÁN DEL <br> 
                        PATRIMONIO EN <br> 
                        EL CAMBIO<br>
                        DE SIGLO
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 23- JORGE BASADRE-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio23/jorge-basadre']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_030.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio23/jorge-basadre']" class="fontMS700 font-16 text-white text-center">
                        JORGE BASADRE<br>
                        Y LA VOCACIÓN<br>
                        BIBLIOTECARIA EN<br>
                        EL PERÚ
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio10/pensadoresXIX']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_002.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio10/pensadoresXIX']" class="fontMS700 font-16 text-white text-center">
                        PENSADORAS <br>
                        PERUANAS <br>
                        DEL SIGLO XIX <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-1">
            </div>
        </div>

        <!--CLORINDA MATO DE TURNER COMIENZA--><!--MORADOS NUEVOS-->
        <div class="row p2" *ngIf="todos == true">
            <div class="col-sm-1">
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio9/clorindaMatto']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_003.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio9/clorindaMatto']" class="fontMS700 font-16 text-white text-center">
                        CLORINDA MATTO <br>
                        DE TURNER <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio8/artePoeta']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_004.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio8/artePoeta']" class="fontMS700 font-16 text-white text-center">
                        EL ARTE DEL POETA<br>
                        JOSÉ MARÍA EGUREN <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio13/magda-portal']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_005.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio13/magda-portal']" class="fontMS700 font-16 text-white text-center">
                        MAGDA PORTAL<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio14/jose-maria-arguedas']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_006.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio14/jose-maria-arguedas']"
                        class="fontMS700 font-16 text-white text-center">
                        JOSÉ MARÍA <br>
                        ARGUEDAS <br>
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 26-MARIA ALVARADO-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio26/maria-alvarado']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_046.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio26/maria-alvarado']"
                        class="fontMS700 font-16 text-white text-center">
                        MARÍA JESÚS <br>
                        ALVARADO RIVERA <br>
                    </p>
                </div>
            </div>


            <div class="col-sm-1">
            </div>
        </div>

        <!--MORADOS NUEVOS-->
        <div class="row p2" *ngIf="todos == true">
            <div class="col-sm-1">
            </div>
            <!--NUEVO MICROSITIO 18-NOTICIEROS xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio34/fernando-garreaud']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_055.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio34/fernando-garreaud']"
                        class="fontMS700 font-16 text-white text-center">
                        FERNANDO<br>
                        GARREAUD <br>
                    </p>
                </div>
            </div>

            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio37/bernardo-alzedo']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_037.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio37/bernardo-alzedo']" 
                        class="fontMS700 font-16 text-white text-center">
                        BERNARDO<br>  ALZEDO
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio38/cesar-vallejo']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_038.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio38/cesar-vallejo']" 
                        class="fontMS700 font-16 text-white text-center">
                        CÉSAR<br> VALLEJO
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio39/maria-wiesse']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_058.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio39/maria-wiesse']" 
                        class="fontMS700 font-16 text-white text-center">
                        MARÍA<br> WIESSE
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio40/angelica-palma']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_059.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio40/angelica-palma']" 
                        class="fontMS700 font-16 text-white text-center">
                        ANGÉLICA<br> PALMA
                    </p>
                </div>
            </div>

            <div class="col-sm-1">
            </div>
        </div>

        <!--VERDES NUEVOS-->
        <div class="row p2 fadeIn" *ngIf="element == true && todos == true">
            <div class="col-sm-1">
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio41/nicomedes-santacruz']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_060.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio41/nicomedes-santacruz']" 
                    class="fontMS700 font-16 text-white text-center">
                        NICOMEDES <br>
                        SANTA CRUZ<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio18/noticieros']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_034.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio18/noticieros']" class="fontMS700 font-16 text-white text-center">
                        REPORTAJE Y <br>
                        PROPAGANDA:<br>
                        NOTICIARIOS <br>
                        CINEMATOGRÁFICOS <br>
                        PERUANOS DE <br> 
                        LOS 40<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio3/retrato-foto']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_007.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio3/retrato-foto']" class="fontMS700 font-16 text-white text-center">
                        EL RETRATO <br>
                        FOTOGRÁFICO <br>
                        EN LIMA <br>
                        (1860-1930) <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio11/retratos-inmigracion']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_008.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio11/retratos-inmigracion']"
                        class="fontMS700 font-16 text-white text-center">
                        LOS RETRATOS <br>
                        DE LA INMIGRACIÓN <br>
                        DEL SIGLO XIX <br>
                    </p>
                </div>
            </div>
           <!--NUEVO MICROSITIO 20-DERECHOS DE LA MUJER xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio2/compositores']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_015.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio2/compositores']" class="fontMS700 font-16 text-white text-center">
                        MÚSICA ANDINA,<br>
                        MESTIZA<br>
                        Y CRIOLLA EN LOS<br>
                        COMPOSITORES<br>
                        ACADÉMICOS<br>
                    </p>
                </div>
            </div>

            <div class="col-sm-1">
            </div>
        </div>

        <div class="row p2 fadeIn" *ngIf="element == true && todos == true">
            <div class="col-sm-1">
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio12/malaga-grenet']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_010.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio12/malaga-grenet']" class="fontMS700 font-16 text-white text-center">
                        RETRATOS <br>
                        DE PRENSA <br>
                        LA PLUMA DE <br>
                        MÁLAGA GRENET <br>

                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio27/album-autografos']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_047.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio27/album-autografos']" class="fontMS700 font-16 text-white text-center">
                        ÁLBUM DE AUTÓGRAFOS <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio21/construccion-tradicion']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_035.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio21/construccion-tradicion']" class="fontMS700 font-16 text-white text-center">
                        LA CONSTRUCCIÓN<br>
                        DE LA TRADICIÓN:<br>
                        ACUARELAS<br> 
                        COSTUMBRISTAS<br>
                        DEL ÁLBUM PRAETORIA
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 29-EX-LIBRIS-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio29/ex-libris']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_048.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio29/ex-libris']" class="fontMS700 font-16 text-white text-center">
                        DETRÁS DE LOS<br>EXLIBRIS EN EL <br>PERÚ <br>
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 31-MODA-SIGLO-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio31/moda-siglo']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_049.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio31/moda-siglo']" class="fontMS700 font-16 text-white text-center">
                        MODA DEL SIGLO XIX<br>
                    </p>
                </div>
            </div>
            
            <div class="col-sm-1">
            </div>
        </div>

        <div class="row p2 fadeIn" *ngIf="element == true && todos == true">
            <div class="col-sm-1">
            </div>
            <!--NUEVO MICROSITIO 20-DERECHOS DE LA MUJER-->
            <div class="col-sm-2 libro p3" >
                <img class="pointer tema" [routerLink]="['/micrositio33/renacer-cenizas']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_054.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio33/renacer-cenizas']" class="fontMS700 font-16 text-white text-center">
                        RENACER DE LAS CENIZAS<br>
                        INCENDIO Y RECUPERACIÓN<br>
                        DE LA BIBLIOTECA NACIONAL<br>
                        DEL PERÚ
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio42/noticieros2']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_034.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio42/noticieros2']" class="fontMS700 font-16 text-white text-center">
                        REPORTAJE Y<br>
                        PROPAGANDA:<br>
                        NOTICIARIOS<br>
                        CINEMATOGRÁFICOS<br>
                        PERUANOS DE<br>
                        LOS 40 (PARTE II)<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio20/derechos-mujer']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_031.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio20/derechos-mujer']" class="fontMS700 font-16 text-white text-center">
                        LOS DERECHOS DE <br>
                        LA MUJER <br>
                        PERUANA <br>
                        (1910-1956)
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio1/federalismo']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_016.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio1/federalismo']" class="fontMS700 font-16 text-white text-center">
                        FEDERALISMO Y<br>
                        RECONSTRUCCIÓN<br>
                        NACIONAL<br>
                        (1895-1899)<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio5/album-republica-peruana']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_009.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio5/album-republica-peruana']"
                        class="fontMS700 font-16 text-white text-center">
                        ÁLBUM<br> REPÚBLICA<br> PERUANA 1900
                    </p>
                </div>
            </div>
            <div class="col-sm-1">
            </div>
        </div>

        <div class="row p2 fadeIn" *ngIf="element == true && todos == true">
            <div class="col-sm-1">
            </div>
                        <!--NUEVO MICROSITIO 25- LA PRENSA DE LA INDEPENDENCIA-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio25/prensa-independencia']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_051.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio25/prensa-independencia']"
                        class="fontMS700 font-16 text-white text-center">
                        LA<br> PRENSA<br> EN LA INDEPENDENCIA
                    </p>
                </div>
            </div>   
            <!--MICROSITIO 30- RETRATOS FAMILIARES-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio30/retratos-familiares']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_050.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio30/retratos-familiares']"
                        class="fontMS700 font-16 text-white text-center">
                        RETRATOS<br> FAMILIARES
                    </p>
                </div>
            </div>
            <!--MICROSITIO 36- sesquicentenario-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio36/sesquicentenario']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_057.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio36/sesquicentenario']"
                        class="fontMS700 font-16 text-white text-center">
                        SESQUICENTENARIO<br> 
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio22/imprenta']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_038.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio22/imprenta']" class="fontMS700 font-16 text-white text-center">
                        LA IMPRENTA,<br>
                        LOS INCUNABLES Y<br> 
                        ESTAMPAS EN EL <br> 
                        VIRREINATO DEL PERÚ
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 24- INCA GARCILAZO DE LA VEGA-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio24/inca-garcilaso']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_037.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio24/inca-garcilaso']" class="fontMS700 font-16 text-white text-center">
                        INCA 
                        GARCILASO<br>
                        DE LA VEGA
                    </p>
                </div>
            </div>
            <div class="col-sm-1">
            </div>
        </div>

        <div class="row p2 fadeIn" *ngIf="element == true && todos == true">
            <div class="col-sm-1"></div>
            <!--NUEVO MICROSITIO 28- Justo Sahuaraura-->
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio28/justo-sahuaraura']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_052.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio28/justo-sahuaraura']" class="fontMS700 font-16 text-white text-center">
                        RECUERDO DE LA <br>
                        MONARQUÍA <br>
                        PERUANA Ó<br>
                        BOSQUEJO DE LA<br>
                        HISTORIA DE LOS <br>
                        INCAS<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio6/gramaticas']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_012.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio6/gramaticas']" class="fontMS700 font-16 text-white text-center">
                        GRAMÁTICAS, <br>
                        CATECISMOS Y <br>
                        VOCABULARIOS <br>
                        EN LENGUAS <br>
                        ORIGINARIAS <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio15/miradas-al-antiguo-peru']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_013.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio15/miradas-al-antiguo-peru']"
                        class="fontMS700 font-16 text-white text-center">
                        MIRADAS AL<br>
                        ANTIGUO PERÚ<br>
                        A INICIOS<br>
                        DEL SIGLO XX<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio4/la-educacion']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_014.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio4/la-educacion']" class="fontMS700 font-16 text-white text-center">
                        LA EDUCACIÓN<br>
                        EXPERIMENTAL<br>
                        EN EL ALTIPLANO <br>
                        (1930-1950)<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio35/lenguas-originarias']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_056.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio35/lenguas-originarias']" class="fontMS700 font-16 text-white text-center">
                        LENGUAS <br>
                        ORIGINARIAS <br>
                    </p>
                </div>
            </div>

            <div class="col-sm-1"></div>
        </div>
        
        <div class="row p2 fadeIn" *ngIf="element == true && todos == true">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio7/himnos']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_011.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio7/himnos']" class="fontMS700 font-16 text-white text-center">
                        COMUNIDADES <br>
                        CANTADAS <br>
                        LAS COMPOSICIONES <br>
                        DE HIMNOS <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
                <img class="pointer tema" [routerLink]="['/micrositio32/memoria-recuperada']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_053.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio32/memoria-recuperada']" class="fontMS700 font-16 text-white text-center">
                        MEMORIA RECUPERADA <br>
                        LOS LIBROS DEVUELTOS <br>
                        POR CHILE
                    </p>
                </div>
            </div>
            <div class="col-sm-2 libro p3">
            </div>
            <div class="col-sm-2 libro p3">
            </div>
            <div class="col-sm-2 libro p3">
            </div>

            <div class="col-sm-1"></div>
        </div>
    </div>

    <!-- TABLET -->

    <div class="col-sm-12 marg menuTablet">
        <div class="row p2">
            <!-- NUEVOS TABLET -->
            <div class="col-sm-6 libro p-3" *ngIf="nuevos == true ||verde == true">
                <img class="pointer tema" [routerLink]="['/micrositio42/noticieros2']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_034.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio42/noticieros2']" class="fontMS700 font-16 text-white text-center">
                        REPORTAJE Y <br>
                        PROPAGANDA:<br>
                        NOTICIARIOS <br>
                        CINEMATOGRÁFICOS <br>
                        PERUANOS DE <br> 
                        LOS 40 (PARTE II)<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="nuevos == true ||morado == true">
                <img class="pointer tema" [routerLink]="['/micrositio41/nicomedes-santacruz']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_060.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio41/nicomedes-santacruz']" class="fontMS700 font-16 text-white text-center">
                        NICOMEDES <br>
                        SANTA CRUZ<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="nuevos == true ||morado == true">
                <img class="pointer tema" [routerLink]="['/micrositio40/angelica-palma']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_059.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio40/angelica-palma']" class="fontMS700 font-16 text-white text-center">
                        ANGÉLICA<br> PALMA <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="nuevos == true ||morado == true">
                <img class="pointer tema" [routerLink]="['/micrositio39/maria-wiesse']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_058.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio39/maria-wiesse']" class="fontMS700 font-16 text-white text-center">
                        MARÍA <br>
                        WIESSE <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="nuevos == true ||morado == true">
                <img class="pointer tema" [routerLink]="['/micrositio38/cesar-vallejo']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_038.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio38/cesar-vallejo']" class="fontMS700 font-16 text-white text-center">
                        CÉSAR <br>
                        VALLEJO <br>
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 34-FERNANDO-GARREAUD-->
            <div class="col-sm-6 libro p-3" *ngIf="nuevos == true ||morado == true">
                <img class="pointer tema" [routerLink]="['/micrositio34/fernando-garreaud']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_055.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio34/fernando-garreaud']" class="fontMS700 font-16 text-white text-center">
                        FERNANDO <br>
                        GARREAUD <br>
                    </p>
                </div>
            </div>


            <!-- TODOS TABLET-->

            <!--NUEVO MICROSITIO 16-DORA MAYER-->
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio16/dora-mayer']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_032.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio16/dora-mayer']" class="fontMS700 font-16 text-white text-center">
                        DORA MAYER<br> 
                        EL SOL QUE DISIPA<br>
                        LAS NUBES
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 17-MANUEL GONZALEZ PRADA-->
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio17/manuel-gonzalez-prada']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_033.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio17/manuel-gonzalez-prada']" class="fontMS700 font-16 text-white text-center">
                        MANUEL <br> 
                        GONZÁLEZ PRADA<br>
                        APUNTES PARA <br>
                        LA HISTORIA
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 19-RICARDO PALMA-->
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio19/ricardo-palma']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_036.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio19/ricardo-palma']" class="fontMS700 font-16 text-white text-center">
                        RICARDO PALMA<br>
                        GUARDIÁN DEL <br> 
                        PATRIMONIO EN <br> 
                        EL CAMBIO<br>
                        DE SIGLO
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 23- JORGE BASADRE-->
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio23/jorge-basadre']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_030.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio23/jorge-basadre']" class="fontMS700 font-16 text-white text-center">
                        JORGE BASADRE<br>
                        Y LA VOCACIÓN<br>
                        BIBLIOTECARIA EN<br>
                        EL PERÚ
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio10/pensadoresXIX']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_002.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio10/pensadoresXIX']" class="fontMS700 font-16 text-white text-center">
                        PENSADORAS <br>
                        PERUANAS <br>
                        DEL SIGLO XIX <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio9/clorindaMatto']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_003.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio9/clorindaMatto']" class="fontMS700 font-16 text-white text-center">
                        CLORINDA MATTO <br>
                        DE TURNER <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio8/artePoeta']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_004.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio8/artePoeta']" class="fontMS700 font-16 text-white text-center">
                        EL ARTE DEL POETA<br>
                        JOSÉ MARÍA EGUREN <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio13/magda-portal']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_005.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio13/magda-portal']" class="fontMS700 font-16 text-white text-center">
                        MAGDA PORTAL<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio14/jose-maria-arguedas']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_006.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio14/jose-maria-arguedas']"
                        class="fontMS700 font-16 text-white text-center">
                        JOSÉ MARÍA <br>
                        ARGUEDAS <br>
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 26-MARIA ALVARADO-->
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio26/maria-alvarado']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_046.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio26/maria-alvarado']"
                        class="fontMS700 font-16 text-white text-center">
                        MARÍA JESÚS <br>
                        ALVARADO RIVERA <br>
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 34-FERNANDO-GARREAUD-->
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio34/fernando-garreaud']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_055.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio34/fernando-garreaud']" class="fontMS700 font-16 text-white text-center">
                        FERNANDO <br>
                        GARREAUD <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio38/cesar-vallejo']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_038.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio38/cesar-vallejo']" class="fontMS700 font-16 text-white text-center">
                        CÉSAR <br>
                        VALLEJO <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio39/maria-wiesse']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_058.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio39/maria-wiesse']" class="fontMS700 font-16 text-white text-center">
                        MARÍA <br>
                        WIESSE <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio40/angelica-palma']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_059.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio40/angelica-palma']" class="fontMS700 font-16 text-white text-center">
                        ANGÉLICA<br> PALMA <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="morado == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio41/nicomedes-santacruz']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_060.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio41/nicomedes-santacruz']" class="fontMS700 font-16 text-white text-center">
                        NICOMEDES <br>
                        SANTA CRUZ<br>
                    </p>
                </div>
            </div>





            <!--NUEVO MICROSITIO 18-NOTICIEROS-->
            <div class="col-sm-6 libro p-3" *ngIf="verde == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio18/noticieros']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_034.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio18/noticieros']" class="fontMS700 font-16 text-white text-center">
                        REPORTAJE Y <br>
                        PROPAGANDA:<br>
                        NOTICIARIOS <br>
                        CINEMATOGRÁFICOS <br>
                        PERUANOS DE <br> 
                        LOS 40<br>
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 21-CONSTRUCCION DE LA TRADICION-->
            <div class="col-sm-6 libro p-3 fadeIn" *ngIf="verde == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio21/construccion-tradicion']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_035.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio21/construccion-tradicion']" class="fontMS700 font-16 text-white text-center">
                        LA CONSTRUCCIÓN<br>
                        DE LA TRADICIÓN:<br>
                        ACUARELAS<br> 
                        COSTUMBRISTAS<br>
                        DEL ÁLBUM PRAETORIA
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="verde == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio3/retrato-foto']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_007.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio3/retrato-foto']" class="fontMS700 font-16 text-white text-center">
                        EL RETRATO <br>
                        FOTOGRÁFICO <br>
                        EN LIMA <br>
                        (1860-1930) <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="verde == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio11/retratos-inmigracion']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_008.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio11/retratos-inmigracion']"
                        class="fontMS700 font-16 text-white text-center">
                        LOS RETRATOS <br>
                        DE LA INMIGRACIÓN <br>
                        DEL SIGLO XIX <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="verde == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio2/compositores']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_015.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio2/compositores']" class="fontMS700 font-16 text-white text-center">
                        MÚSICA ANDINA,<br>
                        MESTIZA<br>
                        Y CRIOLLA EN LOS<br>
                        COMPOSITORES<br>
                        ACADÉMICOS<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="verde == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio12/malaga-grenet']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_010.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio12/malaga-grenet']" class="fontMS700 font-16 text-white text-center">
                        RETRATOS <br>
                        DE PRENSA <br>
                        LA PLUMA DE <br>
                        MÁLAGA GRENET <br>
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 27-ÁLBUM DE AUTÓGRAFOS-->
            <div class="col-sm-6 libro p-3" *ngIf="verde == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio27/album-autografos']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_047.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio27/album-autografos']" class="fontMS700 font-16 text-white text-center">
                        ÁLBUM DE AUTÓGRAFOS <br>
                    </p>
                </div>
            </div>
            
            <!--NUEVO MICROSITIO 29-EX-LIBRIS-->
            <div class="col-sm-6 libro p-3" *ngIf="verde == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio29/ex-libris']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_048.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio29/ex-libris']" class="fontMS700 font-16 text-white text-center">
                        DETRÁS DE LOS<br>EXLIBRIS EN EL <br>PERÚ <br>
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 31-MODA-SIGLO-->
            <div class="col-sm-6 libro p-3" *ngIf="verde == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio31/moda-siglo']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_049.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio31/moda-siglo']" class="fontMS700 font-16 text-white text-center">
                        MODA DEL SIGLO XIX<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="verde == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio33/renacer-cenizas']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_054.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio33/renacer-cenizas']" class="fontMS700 font-16 text-white text-center">
                        RENACER DE LAS CENIZAS<br>
                        INCENDIO Y RECUPERACIÓN<br>
                        DE LA BIBLIOTECA NACIONAL<br>
                        DEL PERÚ
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3" *ngIf="verde == true || todos == true">
                <img class="pointer tema" [routerLink]="['/micrositio42/noticieros2']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_034.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio42/noticieros2']" class="fontMS700 font-16 text-white text-center">
                        REPORTAJE Y<br>
                        PROPAGANDA:<br>
                        NOTICIARIOS<br>
                        CINEMATOGRÁFICOS<br>
                        PERUANOS DE<br>
                        LOS 40 (PARTE II)<br>
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 20-DERECHOS DE LA MUJER-->
            <div class="col-sm-6 libro p-3" *ngIf="(element == true && todos == true) || azul == true">
                <img class="pointer tema" [routerLink]="['/micrositio20/derechos-mujer']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_031.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio20/derechos-mujer']" class="fontMS700 font-16 text-white text-center">
                        LOS DERECHOS DE <br>
                        LA MUJER <br>
                        PERUANA <br>
                        (1910-1956)
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3 fadeIn" *ngIf="(element == true && todos == true) || azul == true">
                <img class="pointer tema" [routerLink]="['/micrositio1/federalismo']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_016.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio1/federalismo']" class="fontMS700 font-16 text-white text-center">
                        FEDERALISMO Y<br>
                        RECONSTRUCCIÓN<br>
                        NACIONAL<br>
                        (1895-1899)<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3 fadeIn" *ngIf="(element == true && todos == true) || azul == true">
                <img class="pointer tema" [routerLink]="['/micrositio5/album-republica-peruana']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_009.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio5/album-republica-peruana']"
                        class="fontMS700 font-16 text-white text-center">
                        ÁLBUM<br> REPÚBLICA<br> PERUANA 1900
                    </p>
                </div>
            </div>

            <!--NUEVO MICROSITIO 25- LA PRENSA DE LA INDEPENDENCIA-->
            <div class="col-sm-6 libro p-3 fadeIn" *ngIf="(element == true && todos == true) || azul == true">
                <img class="pointer tema" [routerLink]="['/micrositio25/prensa-independencia']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_051.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio25/prensa-independencia']"
                        class="fontMS700 font-16 text-white text-center">
                        LA<br> PRENSA<br> EN LA INDEPENDENCIA
                    </p>
                </div>
            </div>
            <!--MICROSITIO 30- RETRATOS FAMILIARES-->
            <div class="col-sm-6 libro p3 fadeIn" *ngIf="(element == true && todos == true) || azul == true">
                <img class="pointer tema" [routerLink]="['/micrositio30/retratos-familiares']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_050.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio30/retratos-familiares']"
                        class="fontMS700 font-16 text-white text-center">
                        RETRATOS<br> FAMILIARES
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p3 fadeIn" *ngIf="(element == true && todos == true) || azul == true">
                <img class="pointer tema" [routerLink]="['/micrositio36/sesquicentenario']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_057.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio36/sesquicentenario']"
                        class="fontMS700 font-16 text-white text-center">
                        SESQUICENTENARIO<br> 
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 22- LA IMPRENTA-->
            <div class="col-sm-6 libro p-3 fadeIn" *ngIf="(element == true && todos == true) || amarillo == true">
                <img class="pointer tema" [routerLink]="['/micrositio22/imprenta']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_038.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio22/imprenta']" class="fontMS700 font-16 text-white text-center">
                        LA IMPRENTA,<br>
                        LOS INCUNABLES Y<br> 
                        ESTAMPAS EN EL <br> 
                        VIRREINATO DEL PERÚ
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 24- INCA GARCILAZO DE LA VEGA-->
            <div class="col-sm-6 libro p-3 fadeIn" *ngIf="(element == true && todos == true) || amarillo == true">
                <img class="pointer tema" [routerLink]="['/micrositio24/inca-garcilaso']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_037.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio24/inca-garcilaso']" class="fontMS700 font-16 text-white text-center">
                        INCA 
                        GARCILASO<br>
                        DE LA VEGA
                    </p>
                </div>
            </div>
            <!--NUEVO MICROSITIO 28- Justo Sahuaraura-->
            <div class="col-sm-6 libro p3 fadeIn" *ngIf="(element == true && todos == true) || amarillo == true">
                <img class="pointer tema" [routerLink]="['/micrositio28/justo-sahuaraura']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_052.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio28/justo-sahuaraura']" class="fontMS700 font-16 text-white text-center">
                        RECUERDO DE LA <br>
                        MONARQUÍA <br>
                        PERUANA Ó<br>
                        BOSQUEJO DE LA<br>
                        HISTORIA DE LOS <br>
                        INCAS<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3 fadeIn" *ngIf="(element == true && todos == true) || amarillo == true">
                <img class="pointer tema" [routerLink]="['/micrositio6/gramaticas']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_012.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio6/gramaticas']" class="fontMS700 font-16 text-white text-center">
                        GRAMÁTICAS, <br>
                        CATECISMOS Y <br>
                        VOCABULARIOS <br>
                        EN LENGUAS <br>
                        ORIGINARIAS <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3 fadeIn" *ngIf="(element == true && todos == true) || amarillo == true">
                <img class="pointer tema" [routerLink]="['/micrositio15/miradas-al-antiguo-peru']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_013.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio15/miradas-al-antiguo-peru']"
                        class="fontMS700 font-16 text-white text-center">
                        MIRADAS AL<br>
                        ANTIGUO PERÚ<br>
                        A INICIOS<br>
                        DEL SIGLO XX<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3 fadeIn" *ngIf="(element == true && todos == true) || amarillo == true">
                <img class="pointer tema" [routerLink]="['/micrositio4/la-educacion']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_014.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio4/la-educacion']" class="fontMS700 font-16 text-white text-center">
                        LA EDUCACIÓN<br>
                        EXPERIMENTAL<br>
                        EN EL ALTIPLANO <br>
                        (1930-1950)<br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3 fadeIn" *ngIf="(element == true && todos == true) || amarillo == true">
                <img class="pointer tema" [routerLink]="['/micrositio7/himnos']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_011.jpg">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio7/himnos']" class="fontMS700 font-16 text-white text-center">
                        COMUNIDADES <br>
                        CANTADAS <br>
                        LAS COMPOSICIONES <br>
                        DE HIMNOS <br>
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3 fadeIn" *ngIf="(element == true && todos == true) || amarillo == true">
                <img class="pointer tema" [routerLink]="['/micrositio32/memoria-recuperada']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_053.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio32/memoria-recuperada']" class="fontMS700 font-16 text-white text-center">
                        MEMORIA RECUPERADA <br>
                        LOS LIBROS DEVUELTOS <br>
                        POR CHILE
                    </p>
                </div>
            </div>
            <div class="col-sm-6 libro p-3 fadeIn" *ngIf="(element == true && todos == true) || amarillo == true"> 
                <img class="pointer tema" [routerLink]="['/micrositio35/lenguas-originarias']" width="100%"
                    src="/assets/images/micrositio/homepage/HOME_056.png">
                <div class="overlay pointer">
                    <p [routerLink]="['/micrositio35/lenguas-originarias']" class="fontMS700 font-16 text-white text-center">
                        LENGUAJES <br>
                        ORIGINARIAS <br>
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div class="col-sm-12" *ngIf="element == false && todos==true">
        <div class="row p2">
            <div class="col-sm-1">
            </div>
            <div class="col-sm-10">
                <div class="row">
                    <div class="col-sm-5"></div>
                    <div class="col-sm-2 text-center" style="border: 1px solid #fff;">
                        <a (click) = "showData()">
                            <p style="line-height: 160%; margin-bottom: 0%;"
                                class="fontMS500 text-white font-24">
                                + TEMAS
                            </p>
                        </a>
                    </div>
                    <div class="col-sm-5"></div>
                </div>
            </div>
            <div class="col-sm-1">
            </div>
        </div>
    </div>

    <div class="col-sm-12" *ngIf="nuevos == true">
        <div class="row p2">
            <div class="col-sm-1">
            </div>
            <div class="col-sm-10">
                <div class="row">
                    <div class="col-sm-5"></div>
                    <div class="col-sm-2 text-center" style="border: 1px solid #fff;">
                        <a (click)="asignar('TODOS')">
                            <label class="{{factiveT}}">
                            <span class="fontMS500 text-white font-24" style="line-height: 160%; margin-bottom: 0%;">+ TEMAS</span>
                            </label>
                        </a>
                    </div>
                    <div class="col-sm-5"></div>
                </div>
            </div>
            <div class="col-sm-1">
            </div>
        </div>
    </div>




</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 font-28 text-center">
                    <img class="imgNP" width="10%" src="/assets/images/micrositio/homepage/HOME_LINEA1-recortada.png">
                    <br><br>
                    UN PAÍS ES UNA MEZCLA DE TRADICIÓN Y DE DESTINO. AL DECIR TRADICIÓN, SE ENTIENDE CONTINUIDAD. Y LA
                    CONTINUIDAD IMPLICA LA NECESIDAD DE LA MEMORIA. (…) ESA CARGA DE PASADO ES LO QUE CONFIERE SU
                    RIQUEZA INTRANSFERIBLE Y SU SABOR ÚNICO A NUESTRA EXISTENCIA PERSONAL. LA MEMORIA, POR ESO, NO ES
                    SÓLO LA CONSERVACIÓN DEL PASADO EN MEDIO DEL PRESENTE: ES TAMBIÉN (FIJÉMONOS EN ESTO) LA
                    COLABORACIÓN DE LO YA VIVIDO EN LA ACTUALIDAD DE LA EXISTENCIA.
                    <br><br>
                    <span class="fontMS500Italic">JORGE BASADRE</span>
                    <br><br>
                    <img class="imgNP" width="10%" src="/assets/images/micrositio/homepage/HOME_LINEA1-recortada.png">
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco" id="recorridos">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/homepage/HOME_LINEA2-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-top: 0%;margin-bottom: 0%;"
                            class="fontMS700 text-center font-40 titleSubsec">
                            RECORRIDOS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/homepage/HOME_LINEA2-recortada3.png">
                    </div>
                </div>
                <div class="row p2">
                    <div class="col-sm-6 r3 imgRecorridos">
                        <a [routerLink]="['/home/generica1']">
                            <img width="100%" src="/assets/images/micrositio/homepage/HOME_039.jpg">
                        </a>
                    </div>
                    <div class="col-sm-6 r3 imgRecorridos">
                        <a [routerLink]="['/home/generica2']">
                            <img width="100%" src="/assets/images/micrositio/homepage/HOME_040.jpg">
                        </a>
                    </div>
                </div>
                <div class="row p2">
                    <div class="col-sm-6 r3 imgRecorridos">
                        <a [routerLink]="['/home/generica3']">
                            <img width="100%" src="/assets/images/micrositio/homepage/HOME_019.jpg">
                        </a>
                    </div>
                    <div class="col-sm-6 r3 imgRecorridos">
                        <a [routerLink]="['/home/generica4']">
                            <img width="100%" src="/assets/images/micrositio/homepage/HOME_020.jpg">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris menuWebPhone" id="documentos">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-7">
                        <p style="line-height: 100%;" class="fontMS700 font-40 titleSubsec">
                            DOCUMENTOS DESTACADOS
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/homepage/HOME_LINEA2-recortada.png">
                    </div>
                </div>
                <!--
                    IMG CON TEXTO EMERGENTE
                -->
                <div class="row">
                    <div class="col-sm-4">
                        <div class="cuadrado1">
                            <a href="http://repositoriodigital.bnp.gob.pe/bnp/recursos/2/memoria-peru/garcilaso/the-royal-commentaries-of-peru-in-two-parts-written-originally-in-spanish/"
                                target="_blank">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_043.jpg">
                            </a>
                            <p style="line-height: 110%;" class="fontMS700 font-24 p-3">
                                <span style="line-height: 100%;" class="font-14 fontMS100 text-grey">
                                    <u>INCA GARCILASO DE LA VEGA</u> <br><br>
                                </span>
                                <a href="http://repositoriodigital.bnp.gob.pe/bnp/recursos/2/memoria-peru/garcilaso/the-royal-commentaries-of-peru-in-two-parts-written-originally-in-spanish/"
                                    style="color: inherit;" target="_blank">
                                    The royal commentaries of Peru : in two parts / written originally in spanish by the 
                                    Inca Garcilasso de la Vega; rendred into english by sir Paul Rycaut. London: Miles 
                                    Flesher, for Jacob Tonson, 1688.
                                </a>
                                <br><br>
                                <span class="font-20 fontMS100 text-dgrey">
                                    Se trata de la primera traducción al inglés de las dos partes de Los Comentarios Reales 
                                    de los Incas. En ese mismo año, Miles Flesher imprimió diversas variantes de esta 
                                    edición, cada una de ellas con un sello editorial diferente.
                                </span>
                            </p>
                            <div class="text-right">
                                <a href="http://repositoriodigital.bnp.gob.pe/bnp/recursos/2/memoria-peru/garcilaso/the-royal-commentaries-of-peru-in-two-parts-written-originally-in-spanish/"
                                    target="_blank" style="color: black;">
                                    <p class="fontMS700 font-18 p-3">
                                        Ver documento >
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="cuadrado2">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/memoria-peru/dora-mayer/el-deber-pro-indigena.pdf "
                                target="_blank">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_044.jpg">
                            </a>
                            <p style="line-height: 110%;" class="fontMS700 font-24 p-3">
                                <span style="line-height: 100%;" class="font-14  fontMS100 text-grey">
                                    <u>DORA MAYER</u> <br><br>
                                </span>
                                <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/memoria-peru/dora-mayer/el-deber-pro-indigena.pdf "
                                    target="_blank" style="color: inherit;">
                                    El primer número de El Deber Pro-Indígena (octubre de 1912). 

                                </a>
                                <br><br>
                                <span class="font-18 fontMS100 text-dgrey">
                                    En 1912, Dora Mayer funda esta revista con el fin de crear «una cátedra de moralidad 
                                    y conciencia pública». En esta publicación, aparecida entre 1912 y 1917, se difunden 
                                    las denuncias recibidas por la Asociación Pro-Indígena y noticias sobre la causa 
                                    indígena.
                                </span>
                            </p>
                            <div class="text-right">
                                <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/memoria-peru/dora-mayer/el-deber-pro-indigena.pdf"
                                    target="_blank" style="color: black;">
                                    <p class="fontMS700 font-18 p-3">
                                        Ver documento >
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="cuadrado3">
                            <a href="http://repositoriodigital.bnp.gob.pe/bnp/recursos/2/memoria-peru/d-de-la-mujer/carta-abierta-de-jose-de-la-riva-aguero-y-osma-1930-dic-11.pdf "
                                target="_blank">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_045.jpg">
                            </a>
                            <p style="line-height: 110%;" class="fontMS700 font-24 p-3">
                                <span style="line-height: 100%;" class=" font-14  fontMS100 text-grey">
                                    <u>DERECHOS DE LA MUJER </u> <br><br>
                                </span>
                                <a href="http://repositoriodigital.bnp.gob.pe/bnp/recursos/2/memoria-peru/d-de-la-mujer/carta-abierta-de-jose-de-la-riva-aguero-y-osma-1930-dic-11.pdf "
                                    target="_blank" style="color: inherit;">

                                    Carta abierta de José de la Riva-Agüero y Osma a Zoila Aurora Cáceres (11 de diciembre de 1930)   
                                </a>
                                <br><br>
                                <span class="font-18 fontMS100 text-dgrey">
                                    En esta carta Riva-Agüero da su opinión favorable al voto político y municipal 
                                    de las mujeres, y se muestra en contra de su exclusión en el sufragio universal 
                                    considerándolo como uno de los contrasentidos más palpables y escandalosos que 
                                    cabe imaginar en un régimen democrático.  
                                </span>
                            </p>
                            <div class="text-right">
                                <a href="http://repositoriodigital.bnp.gob.pe/bnp/recursos/2/memoria-peru/d-de-la-mujer/carta-abierta-de-jose-de-la-riva-aguero-y-osma-1930-dic-11.pdf "
                                    target="_blank" style="color: black;">
                                    <p class="fontMS700 font-18 p-3">
                                        Ver documento >
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris menuTablet" id="documentos">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-7">
                        <p style="line-height: 100%;" class="fontMS700 font-40 titleSubsec">
                            DOCUMENTOS DESTACADOS
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/homepage/HOME_LINEA2-recortada.png">
                    </div>
                </div>
                <!--
                    IMG CON TEXTO EMERGENTE
                -->
                <div class="row">
                    <div class="col-sm-12">
                        <div class="cuadrado1">
                            <a href="https://bibliotecadigital.bnp.gob.pe/portal-bnp-web/#/libro/LIB-2423"
                                target="_blank">

                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_021.jpg">
                            </a>
                            <p style="line-height: 110%;" class="fontMS700 font-24 p-3">
                                <span style="line-height: 100%;" class="font-14 fontMS100 text-grey">
                                    <u>GRAMÁTICAS, CATECISMOS Y VOCABULARIOS EN LENGUAS ORIGINARIAS</u> <br><br>
                                </span>
                                <a href="https://bibliotecadigital.bnp.gob.pe/portal-bnp-web/#/libro/LIB-2423"
                                    style="color: inherit;" target="_blank">
                                    Anónimo. <span class="fontMS700Italic">Tercero Cathecismo</span>. Antonio Ricardo,
                                    1585.
                                </a>
                                <br><br>
                                <span class="font-20 fontMS100 text-dgrey">
                                    <span class="fontMS100Italic">Tercero Cathecismo</span> contiene treintaiún sermones
                                    trilingües
                                    (castellano-quechua-aymara). El libro forma parte de la colección de 39 incunables
                                    peruanos publicados entre 1584 y 1619, custodiados por la Biblioteca Nacional del
                                    Perú. Desde 2013, la colección figura en el registro de la Memoria del Mundo de la
                                    UNESCO.
                                </span>
                            </p>
                            <div class="text-right">
                                <a href="https://bibliotecadigital.bnp.gob.pe/portal-bnp-web/#/libro/LIB-2423"
                                    target="_blank" style="color: black;">
                                    <p class="fontMS700 font-18 p-3">
                                        Ver documento >
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="cuadrado2">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/pdf/carta-de-juana-manuela-gorriti-a-ricardo-palma-27-de-noviembre-de-1882.pdf"
                                target="_blank">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_023.jpg">
                            </a>
                            <p style="line-height: 110%;" class="fontMS700 font-24 p-3">
                                <span style="line-height: 100%;" class="font-14  fontMS100 text-grey">
                                    <u>PENSADORAS PERUANAS DEL SIGLO XIX</u> <br><br>
                                </span>
                                <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/pdf/carta-de-juana-manuela-gorriti-a-ricardo-palma-27-de-noviembre-de-1882.pdf"
                                    target="_blank" style="color: inherit;">
                                    Juana Manuela Gorriti. Carta a Ricardo Palma. 27 de noviembre de 1882.
                                </a>
                                <br><br>
                                <span class="font-18 fontMS100 text-dgrey">
                                    Juana Manuela Gorriti describe su amistad con la monja Isabel Serrano; incluye una
                                    narración sobre una historia de amor entre la monja y el general Alvear que después
                                    le sirve de inspiración a Ricardo Palma para la tradición “Un tenorio americano”.
                                </span>
                            </p>
                            <div class="text-right">
                                <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/pdf/carta-de-juana-manuela-gorriti-a-ricardo-palma-27-de-noviembre-de-1882.pdf"
                                    target="_blank" style="color: black;">
                                    <p class="fontMS700 font-18 p-3">
                                        Ver documento >
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="cuadrado3">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/pdf/himno-nacional-del-peru-reduccion-para-piano-musica-del-maestro-jose-bernardo-alzedo-1821.pdf"
                                target="_blank">

                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_022.jpg">
                            </a>
                            <p style="line-height: 110%;" class="fontMS700 font-24 p-3">
                                <span style="line-height: 100%;" class=" font-14  fontMS100 text-grey">
                                    <u>COMUNIDADES CANTADAS. LAS COMPOSICIONES DE HIMNOS</u> <br><br>
                                </span>
                                <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/pdf/himno-nacional-del-peru-reduccion-para-piano-musica-del-maestro-jose-bernardo-alzedo-1821.pdf"
                                    target="_blank" style="color: inherit;">

                                    José Bernardo Alzedo. Himno Nacional del Perú. Reducción para piano. Restaurado,
                                    armonizado e instrumentado por Claudio Rebagliati. 1901.
                                </a>
                                <br><br>
                                <span class="font-18 fontMS100 text-dgrey">
                                    Desde su creación en 1821, el Himno Nacional del Perú fue modificado varias veces,
                                    generando desacuerdo con algunas de sus versiones. En 1869, el compositor italiano
                                    Claudio Rebagliati realizó una restauración que fue autorizada por el autor original
                                    del himno, José Bernardo Alzedo. Esta versión fue oficializada en 1901, cuando la
                                    comisión nombrada por el Ministerio de Gobierno emite una Resolución Suprema firmada
                                    por el presidente Eduardo López de Romaña donde aprueba las modificaciones de
                                    Rebagliati.
                                </span>
                            </p>
                            <div class="text-right">
                                <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/pdf/himno-nacional-del-peru-reduccion-para-piano-musica-del-maestro-jose-bernardo-alzedo-1821.pdf"
                                    target="_blank" style="color: black;">
                                    <p class="fontMS700 font-18 p-3">
                                        Ver documento >
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="contacto">

</div>